module.exports = __webpack_public_path__ + "SuryaVamsi2-d9a24e8c.png";